/* eslint-disable */
import http from '@/http-common'
import store from '@/store/index'
import Vue from 'vue'

class MainService {
  setDefaultHeaders () {
    http.defaults.headers.common['origin-o'] = store.state.parentLocation.origin
  }

  defaultParams () {
    const params:any = {}

    params.url = Vue.prototype.$widget.urlOrigin()

    return params
  }

  get (data: any) {
    this.setDefaultHeaders()
    const defaultParams = this.defaultParams()

    const params = { ...data.params, ...defaultParams }
    params.code = store.state.parentLocation.organizationCode
    return http.get(data.route, { params })
  }

  post (data: any) {
    this.setDefaultHeaders()
    const defaultParams = this.defaultParams()
    data.params = { ...data.params, ...defaultParams }

    data.params.code = store.state.parentLocation.organizationCode
    return http.post(data.route, data.params)
  }

  formPost (data: any) {
    this.setDefaultHeaders()
    const defaultParams = this.defaultParams()
    data.params = { ...data.params, ...defaultParams }

    data.params.code = store.state.parentLocation.organizationCode
    const params = Object.keys(data.params)
    const formData:any = new FormData()

    if (params[0] === 'files') {
      for (let i = 0; i < data.params[params[0]].length; i++) {
        formData.append(`${params[0]}[]`, data.params[params[0]][i])
      }
    }

    if (params[0] === 'file') {
      params.map((paramName) => {
        formData.append(paramName, data.params[paramName])
      })
    }

    return http.post(data.route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  put (data: any) {
    this.setDefaultHeaders()
    const defaultParams = this.defaultParams()
    data.params = { ...data.params, ...defaultParams }

    data.params.code = store.state.parentLocation.organizationCode
    return http.put(data.route, data.params)
  }

  delete (data: any) {
    this.setDefaultHeaders()
    const defaultParams = this.defaultParams()
    const params = { ...data.params, ...defaultParams }

    params.code = store.state.parentLocation.organizationCode
    return http.delete(data.route, { params })
  }
}

export default new MainService()